import type { ReactNode } from "react";

type DetailItemProps = {
  label: string;
  children: ReactNode;
};

/**
 * Single label/value pair inside a ConnectionDetails grid, matching the
 * definition-list treatment used on the AI Maintenance page.
 */
export const DetailItem = ({ label, children }: DetailItemProps) => (
  <div>
    <dt className="text-sm text-muted-foreground">{label}</dt>
    <dd className="mt-1 font-medium">{children}</dd>
  </div>
);

export const ConnectionDetails = ({ children }: { children: ReactNode }) => (
  <dl className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">{children}</dl>
);
